import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ExpenseMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.expense.expenseMapperError"));

        Object.setPrototypeOf(this, ExpenseMapperError.prototype);
    }
}